import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { initGA4, trackPageView } from '../../utils/analytics';
/**
 * Mounts once inside the router. Boots GA4 and emits exactly one page_view
 * per SPA navigation. `trackPageView` is deduped on the resolved path, so
 * React Strict Mode's double-invoked effects cannot produce duplicate hits.
 */
export function GA4RouteTracker() {
  const location = useLocation();
  useEffect(() => {
    initGA4();
  }, []);
  useEffect(() => {
    trackPageView(`${location.pathname}${location.search}`);
  }, [location.pathname, location.search]);
  return null;
}